module.exports = __webpack_public_path__ + "static/media/lsa_box.c246f61a.png";